import React from "react"
import { BreadCrumb } from "primereact/breadcrumb"
import { Link } from "react-router-dom"
import home from "../../assets/icons/home_icon.svg"

const AppBreadcrumb = ({ items }) => {
  const breadcrumbItems = [
    {
      template: (
        <Link to="/">
          <img src={home} alt="Home" />
        </Link>
      ),
    },
    ...items,
  ]

  return (
    <BreadCrumb model={breadcrumbItems} className="custom-breadcrumb pl-0" />
  )
}

export default AppBreadcrumb
